import type { OrderType } from './OrderTypeChip.type';

export function orderTypeAsFlags(orderType: OrderType) {
  return {
    isNormal: orderType === 'normal',
    isBundle: orderType === 'bundle',
    isPriority: orderType === 'priority',
  };
}
